import type { FormEvent, ReactNode } from "react";
import { UserPlus, UserRound } from "lucide-react";
import { roleLabels, type OrganizationDetail } from "../../account";

type OrganizationTeamPageProps = {
  canAdmin: boolean;
  capacityAvailable: boolean;
  capacityLocked: ReactNode;
  data: Pick<OrganizationDetail, "members">;
  featureAvailable: boolean;
  featureLocked: ReactNode;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
};

export function OrganizationTeamPage({
  canAdmin,
  capacityAvailable,
  capacityLocked,
  data,
  featureAvailable,
  featureLocked,
  onSubmit,
}: OrganizationTeamPageProps) {
  return (
    <section className="account-panel workspace-section">
      <div className="workspace-section-heading">
        <div>
          <span className="eyebrow">Tiimi</span>
          <h2>Jäsenet ja käyttöoikeudet</h2>
          <p>
            Kutsu koskee vain tätä organisaatiotyötilaa eikä anna pääsyä
            henkilökohtaisiin kalastustietoihin.
          </p>
        </div>
        <UserRound />
      </div>
      <div className="organization-list">
        {data.members.map((member, index) => (
          <article key={String(member.id ?? index)}>
            <UserRound />
            <div>
              <b>{String(member.display_name)}</b>
              <span>
                {roleLabels[String(member.role)] ?? String(member.role)} ·{" "}
                {member.status === "active" ? "aktiivinen" : "kutsu odottaa"}
              </span>
            </div>
          </article>
        ))}
      </div>
      {canAdmin &&
        (!featureAvailable ? (
          featureLocked
        ) : !capacityAvailable ? (
          capacityLocked
        ) : (
          <form className="inline-account-form workspace-form" onSubmit={onSubmit}>
            <label>
              Organisaatiotilin sähköposti
              <input name="email" type="email" required />
            </label>
            <label>
              Rooli
              <select name="role" defaultValue="editor">
                <option value="admin">Ylläpitäjä</option>
                <option value="editor">Muokkaaja</option>
                <option value="support">Asiakaspalvelu</option>
                <option value="viewer">Katselija</option>
              </select>
            </label>
            <p className="form-hint">
              Kutsu näkyy vastaanottajalle organisaatiotilille kirjautumisen
              jälkeen. Sähköpostia ei vielä lähetetä.
            </p>
            <div><button><UserPlus /> Lisää kutsu</button></div>
          </form>
        ))}
    </section>
  );
}
